import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";
import { StorageRouterProps } from "../StorageRouterProps";
import AssignmentsTable from "../components/AssignmentsTable";

export interface StorageUserListPageProps extends NSARouterMakerResult, StorageRouterProps { }

class StorageUserListPage extends Component<StorageUserListPageProps>
{
    override render()
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.storage_user(this.props),
                    list: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_user_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    }
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default StorageUserListPage;